<template>
  <div>
    <!-- <el-button @click="imageView">点击</el-button>
    <div class="viewer" v-show="false" v-viewer="{ movable: false }">
      <img v-for="src in pics" :src="src" :key="src" />
    </div> -->
    <viewer class="img-list">
      <div class="img-list-li" v-for="(item, index) in imgList" :key="index">
        <img :src="item.url" />
      </div>
    </viewer>
  </div>
</template>

<script>
export default {
  name: "preview-image",
  props: {
    imgList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {};
  },
  methods: {
    imageView() {
      const viewer = this.$el.querySelector(".viewer").$viewer;
      viewer.show();
    },
  },
};
</script>

<style scoped>
.img-list {
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.img-list-li {
  width: 65px;
  height: 65px;
  border-radius: 4px;
  margin-right: 10px;
  overflow: hidden;
}
.img-list-li > img {
  width: 100%;
  height: 100%;
}
</style>


